/**
 * Project panel
 *
 * Created by stefensuhat on 26/07/18 3.00 PM
 */

import { withStyles } from '@material-ui/core';
import CloseIcon from 'mdi-material-ui/Close';
import SpeedDial from '@material-ui/lab/SpeedDial';
import SpeedDialAction from '@material-ui/lab/SpeedDialAction';
import SpeedDialIcon from '@material-ui/lab/SpeedDialIcon';
import DotsIcon from 'mdi-material-ui/DotsHorizontal';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import compose from 'recompose/compose';

const propTypes = {
    actions: PropTypes.arrayOf(PropTypes.object).isRequired,
    direction: PropTypes.oneOf(['left', 'right', 'up', 'down']),
};
const defaultProps = { direction: 'up' };

const styles = ({ spacing }) => ({
    speedDial: {
        position: 'absolute',
        '&.MuiSpeedDial-directionUp, &.MuiSpeedDial-directionLeft': {
            bottom: spacing(2),
            right: spacing(2),
        },
        '&.MuiSpeedDial-directionDown, &.MuiSpeedDial-directionRight': {
            top: spacing(2),
            left: spacing(2),
        },
    },
});


class speedDial extends Component {
    state = {
        open: false,
        hidden: false,
    };

    handleIconClick = (onClick) => {
        this.setState((state) => ({
            open: !state.open,
        }));

        onClick();
    };

    handleClick = () => {
        this.setState((state) => ({
            open: !state.open,
        }));
    };

    handleOpen = () => {
        const { hidden } = this.state;

        if (!hidden) {
            this.setState({
                open: true,
            });
        }
    };

    handleClose = () => {
        this.setState({
            open: false,
        });
    };

    render() {
        const { classes, actions, direction } = this.props;
        const { hidden, open } = this.state;

        let isTouch;
        if (typeof document !== 'undefined') {
            isTouch = 'ontouchstart' in document.documentElement;
        }

        return (
            <div className={classes.wrapper}>
                <SpeedDial
                    ariaLabel="speed-dial"
                    className={classes.speedDial}
                    direction={direction}
                    hidden={hidden}
                    icon={<SpeedDialIcon icon={<DotsIcon />} openIcon={<CloseIcon />} />}
                    onBlur={this.handleClose}
                    onClick={this.handleClick}
                    onClose={this.handleClose}
                    onFocus={isTouch ? undefined : this.handleOpen}
                    onMouseEnter={isTouch ? undefined : this.handleOpen}
                    onMouseLeave={this.handleClose}
                    open={open}
                >
                    {actions.map((action) => (
                        <SpeedDialAction
                            tooltipOpen
                            title={action.name}
                            key={action.name}
                            icon={action.icon}
                            tooltipTitle={action.name}
                            onClick={() => this.handleIconClick(action.onClick)}
                        />
                    ))}
                </SpeedDial>
            </div>
        );
    }
}

speedDial.propTypes = propTypes;
speedDial.defaultProps = defaultProps;

export default compose(withStyles(styles, { name: 'speedDial' }))(speedDial);
